import { SecurityParameters } from 'services/forgetPassword'

export function hasMinLength(password: string, lenght: number): boolean {
  return password.length >= lenght
}

export function hasNumber(
  password: string,
  securityParameters: SecurityParameters[]
): boolean {
  const validate = securityParameters.some(
    (item) => item.cd_parm === 705 && item.vl_parm === '1'
  )
  if (!validate) {
    return true
  }
  return /\d/.test(password)
}

export function hasUpperCase(
  password: string,
  securityParameters: SecurityParameters[]
): boolean {
  const validate = securityParameters.some(
    (item) => item.cd_parm === 702 && item.vl_parm === '1'
  )
  if (!validate) {
    return true
  }
  return /[A-Z]/.test(password)
}

export function hasLowerCase(
  password: string,
  securityParameters: SecurityParameters[]
): boolean {
  const validate = securityParameters.some(
    (item) => item.cd_parm === 703 && item.vl_parm === '1'
  )
  if (!validate) {
    return true
  }
  return /[a-z]/.test(password)
}

export function hasSpecialCharacter(
  password: string,
  securityParameters: SecurityParameters[]
): boolean {
  const validate = securityParameters.some(
    (item) => item.cd_parm === 704 && item.vl_parm === '1'
  )
  if (!validate) {
    return true
  }
  return /[^a-zA-Z0-9]/.test(password)
}
